import { defineStore } from 'pinia'
import { ref } from 'vue'
import { CommonUrl } from '@/utils/commonUrl'
import { UserStatus, UserType } from '@/types'
import {pendingSettlementOrderApi, userInfoApi} from '@/service'

const init: UserType = {
  uid: null,
  avatar: CommonUrl.NoneLogin_HeadPortrait,
  realName: '未登录',
  phone: '',
  depositDetail: {
    total: 0,
  },
}

const initState = JSON.parse(
  uni.getStorageSync('user') ||
    JSON.stringify({
      userInfo: init,
      access_token: '',
      refresh_token: '',
    }),
)

const editInit = () => {
  return {
    name: '',
    phone: '',
    code: [],
    preAddr: '',
    defAddr: false,
    address: '',
  }
}

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<UserType>(initState.userInfo)

    const accessToken = ref('')
    const refreshToken = ref('')

    // 待处理
    const pendingSettlement = ref(0)

    const setUserInfo = async () => {
      try {
        const res = await userInfoApi()
        if (res.uid) {
          userInfo.value = {
            ...res,
            avatar: res.avatar ? res.avatar : CommonUrl.User_HeadPortrait,
          }
        }
        const pending = await pendingSettlementOrderApi()
        pendingSettlement.value = pending.sell + pending.incoming
      } catch {}
    }

    const setTokenInfo = (val: ITokenInfo) => {
      accessToken.value = val.access_token
      refreshToken.value = val.refresh_token
    }

    const clearUserInfo = () => {
      uni.removeStorageSync('user')
      userInfo.value = init
      accessToken.value = ''
      refreshToken.value = ''
      pendingSettlement.value = 0
    }

    const getMyPageTitle = (type: string = 'my') => {
      switch (userInfo.value?.auth) {
        case UserStatus.UNPOST:
          return '去认证 >'
        case UserStatus.POST:
          return '审核中'
        case UserStatus.FAIL:
          return '去认证'
        default:
          return type === 'my' ? userInfo.value?.realName : ''
      }
    }

    // 用户选择的地址 (编辑--选择的收获的地址)
    const userAddressEdit = ref(editInit())

    const setUserAddressEdit = (fn: () => NonNullable<unknown>) => {
      const editInfo = fn()
      userAddressEdit.value = editInfo || editInit()
    }

    // 用户选择的银行卡
    const userBank = ref({
      num: '',
      bank: '',
      address: '',
      def: false,
    })

    const setUserBank = (fn: () => NonNullable<unknown>) => {
      userBank.value = fn()
    }

    return {
      userInfo,
      pendingSettlement,
      accessToken,
      refreshToken,
      userAddressEdit,
      userBank,
      setUserInfo,
      clearUserInfo,
      getMyPageTitle,
      setTokenInfo,
      setUserAddressEdit,
      setUserBank,
    }
  },
  {
    persist: true,
  },
)
